const script = document.querySelector('script[data-bs-stock-collections]');
const handles = new Set((script?.dataset.bsStockCollections || '').split('|').filter(Boolean));

function normalizeCollectionLink(anchor) {
  if (!(anchor instanceof HTMLAnchorElement) || !anchor.hasAttribute('href')) return;
  let url;
  try {
    url = new URL(anchor.href, window.location.href);
  } catch {
    return;
  }
  if (url.origin !== window.location.origin) return;
  const parts = url.pathname.split('/').filter(Boolean);
  const collectionIndex = parts.indexOf('collections');
  if (collectionIndex < 0 || !handles.has(parts[collectionIndex + 1])) return;
  if (parts.includes('products') || parts.length > collectionIndex + 3) return;
  if (url.searchParams.getAll('filter.v.availability').length === 1 && url.searchParams.get('filter.v.availability') === '1') return;
  url.searchParams.set('filter.v.availability', '1');
  anchor.href = url.pathname + url.search + url.hash;
}

function normalizeLinks(root) {
  if (root instanceof HTMLAnchorElement) normalizeCollectionLink(root);
  root.querySelectorAll?.('a[href]').forEach(normalizeCollectionLink);
}

if (handles.size) {
  normalizeLinks(document);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') normalizeCollectionLink(mutation.target);
      else mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) normalizeLinks(node);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
}
